/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaFlujosVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaFlujos: React.FunctionComponent<ITablaFlujosVistaProps & InjectedIntlProps> = ({
    flujoss,
    cargarFlujos,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={flujoss}
            actions={acciones(manejarFormulario, cargarFlujos, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaFlujos);
